/**
 * Sticky Kaufleiste auf der PDP (Konzept: docs/mockups/pdp-sticky-buybar.html).
 *
 * Aufgaben, absichtlich klein gehalten:
 *  1. ein-/ausblenden, sobald der echte CTA den Viewport verlaesst
 *  2. den disabled-Zustand des echten CTA spiegeln (ausverkauft, 0-%-Gate)
 *  3. den Listen-Weg nach dem Merken zeigen (mobil kurz, ab 1000 px dauerhaft)
 *  4. den Wecker-Status in der zweiten Zeile nachtragen
 *
 * Das Kaufen selbst steht NICHT hier: der Knopf traegt form="<echtes Formular>"
 * und submittet es direkt. Kein Klon, keine Zustandssynchronisation.
 *
 * Plain-Script, import-frei — dieselbe Entscheidung wie tp-add-to-cart.js:
 * ein fehlschlagender ESM-Import haengt sonst die ganze Leiste auf.
 */
(function () {
  var bar = document.querySelector('[data-tp-buybar]');
  if (!bar) return;

  var cta = document.querySelector(bar.dataset.ctaSel || '.tp-pdp__cta');
  if (!cta) return; // keine Buybox (z. B. reines Vorschau-Template) -> Leiste bleibt weg

  var mine = bar.querySelector('[data-tp-buybar-cta]');
  var toList = bar.querySelector('[data-tp-buybar-tolist]');
  var nOut = bar.querySelector('[data-tp-buybar-n]');
  var alertOut = bar.querySelector('[data-tp-buybar-alert]');
  var DESK = window.matchMedia('(min-width: 1000px)');
  var HOLD = 5000; // ms, die der Listen-Weg mobil nach dem Merken stehen bleibt
  var holdTimer = null;

  /* ── 1. sichtbar/unsichtbar ─────────────────────────────────────────────
     inert statt nur unsichtbar: sonst tabbt man in Knoepfe, die niemand sieht. */
  var wanted = false;
  function apply() {
    // Solange der Cart-Drawer offen ist, hat die Leiste dort nichts zu suchen —
    // er deckt ab 480 px die rechte Seite und damit den CTA.
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    var blocked = !!(drawer && drawer.hasAttribute('open')) || !!document.querySelector('dialog[open]');
    var show = wanted && !blocked;
    if (show === !bar.hidden) return;
    if (show) {
      bar.hidden = false;
      bar.removeAttribute('inert');
      requestAnimationFrame(function () { bar.classList.add('is-shown'); });
    } else {
      bar.classList.remove('is-shown');
      bar.setAttribute('inert', '');
      // hidden erst nach der Bewegung, sonst springt sie weg statt zu fahren
      setTimeout(function () { if (!bar.classList.contains('is-shown')) bar.hidden = true; }, 260);
    }
  }

  new IntersectionObserver(function (entries) {
    var e = entries[0];
    // Nur wenn der CTA nach OBEN aus dem Bild ist. Mobil liegt er beim Laden bei
    // y ~836 und war nie sichtbar — ohne die Richtungspruefung stuende die Leiste
    // sofort beim Seitenaufruf da, obwohl man den echten Knopf noch vor sich hat.
    wanted = !e.isIntersecting && e.boundingClientRect.top < 0;
    apply();
  }, { rootMargin: '0px 0px -10px 0px' }).observe(cta);

  document.addEventListener('click', function () { setTimeout(apply, 60); }, true);

  // Der Drawer oeffnet erst nach dem AJAX, also ~1 s nach dem Klick — ein einmaliger
  // Blick 60 ms spaeter verpasst ihn. Am Attribut haengen statt raten.
  var cartDrawer = document.querySelector('theme-drawer#cart-drawer');
  if (cartDrawer) {
    new MutationObserver(apply).observe(cartDrawer, { attributes: true, attributeFilter: ['open'] });
  }

  /* ── 2. gesperrt-Zustand erben ──────────────────────────────────────────
     Ausverkauft und das 0-%-Kauf-Gate setzen disabled am echten Knopf; tp-pv-gate.js
     nimmt es nach der Betreibererklaerung wieder weg. Spiegeln statt die Liquid-Logik
     ein zweites Mal zu bauen. */
  var ctaText = mine ? mine.querySelector('.tp-buybar__ctat') : null;
  var ctaTextHtml = ctaText ? ctaText.innerHTML : '';

  function mirror() {
    if (!mine) return;
    mine.disabled = cta.disabled;
    if (!ctaText) return;
    // Beim 0-%-Gate sagen, WARUM gesperrt ist — und zurueckschalten, sobald
    // tp-pv-gate.js nach der Betreibererklaerung wieder freigibt. Ohne den
    // else-Zweig bliebe „Erklaerung noetig" an einem laengst freien Knopf stehen.
    if (cta.hasAttribute('data-tp-pv-locked') && !cta.hasAttribute('data-tp-pv-soldout')) {
      ctaText.textContent = 'Erklärung nötig ↑';
    } else if (ctaText.innerHTML !== ctaTextHtml) {
      ctaText.innerHTML = ctaTextHtml;
    }
  }
  mirror();
  new MutationObserver(mirror).observe(cta, { attributes: true, attributeFilter: ['disabled', 'data-tp-pv-locked'] });

  // Gesperrter Knopf scrollt zur Buybox, statt stumm zu bleiben.
  if (mine) {
    mine.addEventListener('click', function (e) {
      if (!mine.disabled) return;
      e.preventDefault();
      cta.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  }

  /* ── 3. Merken-Split + 4. Wecker-Status ─────────────────────────────────
     Quellen sind dieselben wie in der Me-Bar: TPLikes.list() / TPLikes.alerts(),
     Ereignisse tp:likes und tp:alerts. */
  function euro(cents) {
    return (window.TPLikes && TPLikes.euro) ? TPLikes.euro(cents) : '';
  }

  function paint() {
    if (!window.TPLikes) return;
    var n = TPLikes.list().length;
    if (nOut) nOut.textContent = n ? String(n) : '';
    // Der sichtbare Text kuerzt je nach Breite bis auf die blosse Zahl — der
    // zugaengliche Name muss die Bedeutung deshalb selbst tragen.
    if (toList) toList.setAttribute('aria-label', n ? 'Zur Merkliste, ' + n + ' gemerkt' : 'Zur Merkliste');
    // Ab 1000 px dauerhaft, sobald ueberhaupt etwas auf der Liste liegt (Variante A).
    if (toList && DESK.matches) {
      toList.hidden = n === 0;
      bar.classList.remove('is-held');
    }

    if (!alertOut) return;
    var id = String((document.querySelector('[data-tp-alert]') || {}).dataset ? document.querySelector('[data-tp-alert]').dataset.productId : '');
    var mineAlert = TPLikes.alerts().filter(function (a) { return String(a.product_id) === id; })[0];
    if (mineAlert && mineAlert.target_cents) {
      alertOut.textContent = 'Wecker bei ' + euro(mineAlert.target_cents);
      alertOut.hidden = false;
    } else {
      alertOut.hidden = true;
    }
  }

  /* Nachklapp (Variante C, mobil): der Listen-Weg klappt beim Merken kurz auf.
     Nicht kurz nach dem Klick nachsehen — tp-likes.js setzt den Zustand erst,
     wenn der Server geantwortet hat. Stattdessen den Klick vormerken und beim
     naechsten tp:likes entscheiden. */
  /* Nachklapp (Variante C, mobil): der Listen-Weg klappt kurz auf, sobald dieses
     Geraet neu auf der Liste landet.

     Bewusst NICHT am Klick aufgehaengt: tp-likes.js reagiert schon auf pointerdown
     und feuert tp:likes, bevor das click-Ereignis ueberhaupt entsteht (im Protokoll
     nachgemessen — tp:likes kam vor dem Klick). Jede Vormerkung per Klick ist damit
     grundsaetzlich zu spaet, auch in der Capture-Phase.

     Stattdessen der Zustandsuebergang „war nicht drin -> ist drin". Das ist nicht nur
     robuster, es ist auch richtiger: merkt jemand oben in der Buybox, zeigt die
     Leiste den Weg trotzdem. */
  var warDrin = null;

  function istDrin() {
    var like = bar.querySelector('.tp-like--bar');
    var pid = like && like.dataset.productId;
    if (!pid || !window.TPLikes) return null;
    return TPLikes.list().some(function (l) { return String(l.product_id) === String(pid); });
  }

  function afterLike() {
    var drin = istDrin();
    if (drin === null) return;
    var neu = warDrin === false && drin === true;
    warDrin = drin;
    if (!neu || !toList || DESK.matches) return;
    toList.hidden = false;
    bar.classList.add('is-held');
    clearTimeout(holdTimer);
    holdTimer = setTimeout(function () {
      bar.classList.remove('is-held');
      toList.hidden = true;
    }, HOLD);
  }

  /* ── 5. Preiswecker ────────────────────────────────────────────────────
     Kein zweiter Dialog: tp-price-alert.js delegiert ueber
     closest('[data-tp-alert]'), ein Knopf ausserhalb dieses Blocks findet den
     Kontext nicht. Die Glocke loest deshalb den echten Oeffner aus — dasselbe
     Prinzip wie der Kauf-Knopf, der per form-Attribut das echte Formular
     submittet. Alle Sonderfaelle (eingeloggt, gestellt, Einwilligung, Dialog)
     bleiben damit an genau einer Stelle. */
  var bells = bar.querySelectorAll('[data-tp-buybar-bell]');

  function echterOeffner() {
    // Eingeloggt: Knopf mit [data-tp-alert-open]. Ausgeloggt: der Link zum Login.
    return document.querySelector('[data-tp-alert] [data-tp-alert-open], [data-tp-alert] a.tp-alert__line');
  }

  for (var i = 0; i < bells.length; i++) {
    bells[i].addEventListener('click', function () {
      var o = echterOeffner();
      if (o) o.click();
    });
  }

  function paintBell() {
    if (!bells.length || !window.TPLikes || !TPLikes.alertFor) return;
    var vid = bar.dataset.variantId;
    var a = vid ? TPLikes.alertFor(vid) : null;
    for (var j = 0; j < bells.length; j++) {
      var el = bells[j];
      if (el.classList.contains('tp-buybar__cta')) continue; // der Ausverkauft-Knopf bleibt, wie er ist
      el.classList.toggle('is-on', !!a);
      el.setAttribute('aria-label', a && a.target_cents
        ? 'Preiswecker steht bei ' + euro(a.target_cents) + ', ändern'
        : 'Preiswecker für dieses Gerät');
    }
  }

  document.addEventListener('tp:likes', function () { paint(); afterLike(); });
  document.addEventListener('tp:alerts', function () { paint(); paintBell(); });
  DESK.addEventListener('change', paint);
  paint();
  paintBell();
  warDrin = istDrin();
})();
